import request from '@/utils/request'

// 员工导出
export function exportSalary(data) {
  return request({
    url: 'api/v2/export/salary',
    method: 'post',
    data
  })
}